// league-display.js -- how a league KEY is presented. Single job: label, emoji
// and league-logo URL for a league. Reads SUPPORTED_LEAGUES (the only client
// league list); writes nothing; no React.
//
// Design intention (Nicky, 2026-09-16): the app is not hardcoded to one league.
// Label (key.toUpperCase()) and the ESPN logo slug (== key) are DERIVED, so the
// only per-league table here is the emoji, and the drift test in
// src/__tests__/lib/league-display.test.js pins its keys to SUPPORTED_LEAGUES.
// Own-property guards keep a poisoned key ("constructor") from resolving to an
// Object.prototype member (same trust-boundary fix player-stats-display had).
import { SUPPORTED_LEAGUES } from './constants';

export const LEAGUE_EMOJI = Object.freeze({ nhl: '🏒', mlb: '⚾', nfl: '🏈' });
const UNKNOWN_EMOJI = '🏟';

const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export function leagueLabel(league) {
  return String(league || '').toUpperCase();
}

export function leagueEmoji(league) {
  return has(LEAGUE_EMOJI, league) ? LEAGUE_EMOJI[league] : UNKNOWN_EMOJI;
}

// null (not a URL) outside the registry so an unknown league key can never
// build an arbitrary image path.
export function leagueLogoUrl(league) {
  return SUPPORTED_LEAGUES.includes(league)
    ? `https://a.espncdn.com/i/teamlogos/leagues/500/${league}.png`
    : null;
}
